import { COMPLEXITY_ITEMS } from "@/data/content";

export default function EstimateBreakdown({ fees, selected, states }) {
  if (!fees) return null;
  const feeFor = (id) => (fees.items || []).find((f) => f.id === id);
  const rows = [
    {
      key: "base",
      label: "Base return",
      min: Number(fees.base_min) || 0,
      max: Number(fees.base_max) || 0,
      prefix: "",
    },
    ...selected
      .map((id) => {
        const f = feeFor(id);
        if (!f) return null;
        return {
          key: id,
          label: COMPLEXITY_ITEMS.find((i) => i.id === id)?.label || id,
          min: Number(f.min) || 0,
          max: Number(f.max) || 0,
          prefix: "+",
        };
      })
      .filter(Boolean),
  ];
  if (states.length > 0) {
    const ms = feeFor("multi-state");
    if (ms) {
      rows.push({
        key: "states",
        label: `Per state filed × ${states.length}`,
        min: states.length * (Number(ms.min) || 0),
        max: states.length * (Number(ms.max) || 0),
        prefix: "+",
      });
    }
  }
  return (
    <div data-testid="estimate-breakdown" className="mt-4 space-y-1.5 border-t border-steel-border/60 pt-4">
      {rows.map((r) => (
        <div key={r.key} data-testid={`estimate-line-${r.key}`} className="flex items-baseline justify-between gap-4 font-mono text-[11px]">
          <span className="text-steel-muted">{r.label}</span>
          <span className="shrink-0 text-steel-secondary">
            {r.prefix}${r.min.toLocaleString()} – ${r.max.toLocaleString()}
          </span>
        </div>
      ))}
    </div>
  );
}
